<template>
  <div>
  <kendo-notification ref="notificationRef"
                      :autoHideAfter="0"
                      :templates="templates"
                      :hideOnClick="false"
                      :button="true"
                      :closable="true"
  >
  </kendo-notification>
  </div>
</template>

<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "LogisticsNotification",
  mounted() {
    const vm = this
    vm.notification = vm.$refs.notificationRef.kendoWidget();
    if (location.hostname.includes('local')) {
      vm.startInterval(120) // 120초마다
    } else {
      vm.startInterval(15) // 15초마다
    }
  },
  methods: {
    getNotiPopup () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/manage/noti/getNotiPopup.json`
      const param = {
        loginUserToken: vm.loginUserToken
      }
      ApiUtil.post(url, param, {isShowLoadingBar : false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          if (response.data.resultStatus.messageCode === '4015') {
            // 토큰 만료 -> 로그아웃 처리
            sessionStorage.clear()
            setTimeout(function () {
              window.location.href = '/login'
            }, 300)
          } else {
            return false
          }
        } else {
          vm.notiData = response.data.resultData
          if (vm.notiData !== undefined && vm.notiData !== null) {
            if (vm.notiData.notiId === null) {
              // null 넘어오면 팝업 숨기기
              vm.notification.hide()
            } else {
              vm.notification.hide() // 한번 지우기
              vm.notification.show(vm.notiData)
              // 클릭 이벤트 세팅
              vm.setOnClose()
              vm.setGoClickRedirectToDetail()
            }
          }
        }
      })
    },
    setOnClose () {
      const vm = this
      document.getElementsByName("on-close").forEach(item=>{
        let targetElement = item
        item.onclick = async function (e) {
          const notiId = targetElement.getAttribute('notiId')
          vm.notification.hide()
          if (!!notiId) {
            setTimeout(async () => {
              await vm.updateNotiStatus([notiId])
              await vm.getNotiPopup()
            }, 1000)
          }
        }
      })
    },
    setGoClickRedirectToDetail(){
      const vm = this
      document.getElementsByName("go-notification").forEach(item=>{
        let targetElement = item
        item.onclick = async function (e) {
          const notiId = targetElement.getAttribute('notiId')
          const targetUrl = targetElement.getAttribute('targetUrl')
          const targetData = JSON.parse(targetElement.getAttribute('targetData'))
          let targetIdList = targetElement.getAttribute('targetId')
          targetIdList = EtnersCommonUtil.isEmpty(targetIdList) ? [] : targetIdList.split(",")

          vm.updateNotiStatus([notiId]).then(() => {
            if (targetIdList.length > 1 || targetIdList.length === 0) {
              // 목록으로 이동
              sessionStorage.setItem("NOTI_PARAMS", kendo.stringify(targetData))
              location.href = `${targetUrl}`
            } else {
              // 상세로 이동
              location.href = `${targetUrl}/${targetIdList[0]}`
            }
            vm.getNotiPopup()
          })
        }
      })
    },
    updateNotiStatus: function (notiIdList) {
      const vm = this
      // 읽음 상태로 업데이트
      let url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/manage/noti/updateNoti.json`
      let params = {
        loginUserToken: vm.loginUserToken,
        notiIdList: notiIdList,
        isPopUp: true,
      }
      return new Promise((resolve, reject) => {
        ApiUtil.post(url, params, {isShowLoadingBar : false}).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            reject()
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            reject()
          } else {
            resolve()
          }
        })
      })
    },
    generateTemplate: function () {
      let template = ''
      template = `<div class="task_alert">
                    <div class="task_close">
                      <div class="k-window-actions">
                        <a role="button" aria-label="Close" class="k-button k-button-icon k-window-action k-bare">
                          <span name="on-close" class="k-icon k-i-close" notiId="#: notiId #"></span>
                        </a>
                      </div>
                    </div>
                    <div class="task_txt">
                        <b class="txt_b">#: notiTitle #</b><br/>
                        #: notiContents #<br/>
                        <div style="font-size:13px;">(#: frstRgstDt #)</div>
                    </div>
                    <div name="go-notification" aria-label="Close" class="task_go" notiId="#: notiId #" targetUrl="#: targetUrl #" targetId="#: targetId #" targetData="#: targetData #">
                        바로가기
                    </div>
                  </div>`

      return kendo.template(template)
    },
    startInterval: function(seconds) {
      const vm = this
      vm.getNotiPopup()

      return setInterval(function(){
        vm.getNotiPopup()
      },seconds*1000)
    }
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      templates: [{
        type: "info",
        template : this.generateTemplate()
      }],
      notiData: {},
    }
  }
}
</script>

<style scoped>
.path .k-i-close:before{
  content : '';
}
.k-notification{
  border-width: 0px;
}
.xicon .k-i-close:before{
  font-size:20px;
}
</style>